import React from 'react';
import { IconProps, Icons, SVGProps } from './Icon.types';

const Icon = ({ className, icon, srText, width, height, color }: IconProps) => {
  const IconComponent: (props: SVGProps) => JSX.Element = Icons[icon];

  return (
    <>
      {srText && <span className="sr-only">{srText}</span>}
      {IconComponent ? (
        <IconComponent
          className={className}
          width={width}
          height={height}
          color={color}
        />
      ) : null}
    </>
  );
};

export default Icon;
